import { mapActions } from 'vuex';

export default {
	computed: {
		fileUploaded() {
			return this.form.laserFormFileName ? true : false;
		},
		fileNameUploaded() {
			return this.form.laserFormFileName;
		}
	},
	methods: {
		...mapActions('form', ['getPdfFile']),
		async getFile() {
			await this.getPdfFile(this.form.pdfData)
				.then(response => {
					if (response.byteLength > 0) {
						this.showFile(response);
					}
				})
				.catch();
		},
		showFile(response) {
			const type = 'pdf';
			var newBlob = new Blob([response], {
				type: `application/${type}`
			});
			const fileUrl = URL.createObjectURL(newBlob);

			window.open(fileUrl, '_blank');
		}
	}
};
